export const dispatchNewEvent = (
  event: string,
  detail: unknown = null
): boolean => {
  const triggerEvent = new window.CustomEvent(event, { detail });
  return document.body.dispatchEvent(triggerEvent);
};
